<template>
  <div class="navbar">
    <div class="logo">
      <router-link to="/index">
        <div class="jump">
          <img style="height: 30px" src="../assets/logoNew.png" />
        </div>
      </router-link>
      <span class="name" style="margin-left: 32px"> {{ name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      u_avatar: "",
      u_nickname: "",
      unreadCount: 0,
    };
  },
  created() {},
  props: {
    name: {
      type: String,
      default: () => "",
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  // max-width: 1920px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  width: 100%;
  box-sizing: border-box;
  display: flex;
  .logo {
    padding-left: 48px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    line-height: 84px;
    background: #fff;
    color: #002140;
    /* cursor: pointer; */
    .jump {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    .name {
      font-size: 14px;
      font-weight: 500;
    }
  }
}
</style>
